import { mediaQueries } from "@shared/ui.design-system";

import { useMediaQuery } from "./useMediaQuery";

export const useMediaQueries = () => {
  const isXs = useMediaQuery(mediaQueries.below.xs);
  const isSm = useMediaQuery(mediaQueries.below.sm);
  const isMd = useMediaQuery(mediaQueries.below.md);
  const isLg = useMediaQuery(mediaQueries.below.lg);

  return {
    isXs,
    isSm,
    isMd,
    isLg
  };
};
